import styled from "styled-components";
import { theme } from "@app/styles/theme";

const Paragraph = styled.p`
  text-align: center;
  color: ${theme.color.textLight};
  padding: 40px 0 40px 0;
`;

export default Paragraph;